import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { usePaymentInputs } from 'react-payment-inputs';
import images from 'react-payment-inputs/images';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const PaymentInput = (props) => {
	const { checkoutInformation, handleUpdateForm } = props;

	const {
		meta,
		getCardImageProps,
		getCardNumberProps,
		getExpiryDateProps,
		getCVCProps
	} = usePaymentInputs();
	const { erroredInputs, touchedInputs } = meta;
	const [showCard, setShowCard] = useState(false);

	const handleMouseDown = (event) => event.preventDefault();

	return (
		<Stack mt={2}>
			<Stack direction='row' alignItems='center'>
				<svg {...getCardImageProps({ images })} style={{ fontSize: '40px' }} />
				<TextField
					id='card-number-input'
					inputProps={{
						...getCardNumberProps({
							onChange: (e) => handleUpdateForm('cardNumber', e.target.value)
						}),
						style: {
							WebkitTextSecurity: showCard ? 'none' : 'disc',
							textSecurity: showCard ? 'none' : 'disc'
						}
					}}
					inputRef={getCardNumberProps().ref}
					value={checkoutInformation.cardNumber}
					fullWidth
					error={touchedInputs.cardNumber && erroredInputs.cardNumber && true}
					helperText={touchedInputs.cardNumber && erroredInputs.cardNumber}
					sx={{ m: 1 }}
					InputProps={{
						endAdornment: (
							<InputAdornment position='end'>
								<IconButton
									aria-label={showCard ? 'hide the card number' : 'display the card number'}
									onClick={() => setShowCard(!showCard)}
									onMouseDown={handleMouseDown}
									onMouseUp={handleMouseDown}
									edge='end'
								>
									{showCard ? <VisibilityOff /> : <Visibility />}
								</IconButton>
							</InputAdornment>
						)
					}}
				/>
			</Stack>
			<Stack direction='row'>
				<TextField
					id='card-expiration-input'
					inputProps={{
						...getExpiryDateProps({
							onChange: (e) => handleUpdateForm('expirationDate', e.target.value)
						})
					}}
					value={checkoutInformation.expirationDate}
					error={touchedInputs.expiryDate && erroredInputs.expiryDate && true}
					helperText={touchedInputs.expiryDate && erroredInputs.expiryDate}
					sx={{ m: 1 }}
				/>
				<TextField
					id='card-cvv-input'
					inputProps={{
						...getCVCProps({
							onChange: (e) => handleUpdateForm('cardCode', e.target.value)
						})
					}}
					value={checkoutInformation.cardCode}
					error={touchedInputs.cvc && erroredInputs.cvc && true}
					helperText={touchedInputs.cvc && erroredInputs.cvc}
					sx={{ m: 1 }}
				/>
			</Stack>
		</Stack>
	);
};

PaymentInput.propTypes = {
	checkoutInformation: PropTypes.object,
	handleUpdateForm: PropTypes.func
};

export default PaymentInput;
